import {
  blobInstance,
  formDataInstance,
  gatewayInstance,
} from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const addDocumentData = async (data) => {
  await gatewayInstance.post(`${SERVICE_ENDPOINT.TRANSPORT}/document`, data);
};

export const addAndUpload = async (data) => {
  try {
    const response = await formDataInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/upload`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateAndUpload = async (data) => {
  try {
    const response = await formDataInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/upload`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getDocumentByOpeAndRef = async (ope, ref) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/byopeandref/${ope}/${ref}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getDocumentByMultipleOpeAndRef = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/bymultipleopeandref`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getFile = async (id) => {
  try {
    const response = await blobInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/download/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getDownscaledFile = async (id) => {
  try {
    const response = await blobInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/download/downscaled/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getDocumentById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getDocumentByOpeAndRefAndDocCat = async (ope, ref, docCat) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/byopeandrefanddoccat/${ope}/${ref}/${docCat}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getDocumentByOpeAndRefAndDocCatAndFileName = async (
  ope,
  ref,
  docCat,
  fileName,
) => {
  try {
    const response = await gatewayInstance.get(
      `/${SERVICE_ENDPOINT.TRANSPORT}/document/byopeandrefanddoccatandfilename/${ope}/${ref}/${docCat}/${fileName}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getDocumentByOpeAndRefDownscaled = async (ope, ref) => {
  try {
    const response = await gatewayInstance.get(
      `/${SERVICE_ENDPOINT.TRANSPORT}/document/byopeandref/downscaled/${ope}/${ref}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getDocumentByOpeAndRefAndDocCatDownscaled = async (
  ope,
  ref,
  docCat,
) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/byopeandrefanddoccat/downscaled/${ope}/${ref}/${docCat}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getDocumentByOpeAndRefAndDocCatAndExcludeFile = async (
  ope,
  ref,
  docCat,
) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/byopeandrefanddoccatandfilename/downscaled/${ope}/${ref}/${docCat}`,
    );
    return Array.isArray(response.data)
      ? response.data
      : response.data?.data ?? [];
  } catch (e) {
    console.error(e);
  }
};

export const getDocumentByOpeAndRefAndDocCatAndFileNameDownscaled = async (
  ope,
  ref,
  docCat,
  fileName,
) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/byopeandrefanddoccatandfilename/downscaled/${ope}/${ref}/${docCat}/${fileName}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const deleteDocument = async (id) => {
  try {
    await gatewayInstance.delete(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/${id}`,
    );
  } catch (e) {
    console.error(e);
  }
};

export const deleteDocumentList = async (deletedList) => {
  try {
    await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/document/delete`,
      deletedList,
    );
  } catch (e) {
    console.error(e);
  }
};
